import { useState } from 'react'
import {
  Button,
  FullScreenDialog,
  SizableText,
  XStack,
  YStack,
  isWeb,
  shadowStandard,
} from '@my/ui'
import { GroupPostReported, ReportGroupFormData, ReportGroupPostForm } from './components'
import { X } from '@tamagui/lucide-icons'

export interface ReportGroupPostModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSubmit: (data: ReportGroupFormData) => void
  onUndoReport: () => void
}

export const ReportGroupPostModal = (props: ReportGroupPostModalProps) => {
  const [submitted, setSubmitted] = useState(false)

  const handleOpenChange = (open: boolean) => {
    setSubmitted(false)
    props.onOpenChange(open)
  }

  const handleSubmit = (data: ReportGroupFormData) => {
    props.onSubmit(data)
    setSubmitted(true)
  }

  const handleUndoReport = () => {
    setSubmitted(false)
    props.onUndoReport()
    props.onOpenChange(false)
  }

  return (
    <FullScreenDialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      portalProps={{
        p: isWeb ? '$3.5' : '$0',
      }}
      contentProps={{
        maxWidth: 600,
      }}
    >
      <XStack
        btlr="$3"
        btrr="$3"
        px="$2"
        py="$3"
        ai="center"
        bg="$white"
        gap="$2"
        {...shadowStandard}
      >
        <Button
          size="$3"
          px="$2"
          icon={<X size={24} />}
          plain
          onPress={() => handleOpenChange(false)}
        />
        <SizableText size="$4" fow="600">
          Report
        </SizableText>
      </XStack>
      <YStack bg="$offWhite" p="$3.5">
        {submitted ? (
          <GroupPostReported
            onClose={() => handleOpenChange(false)}
            onUndoReport={handleUndoReport}
          />
        ) : (
          <ReportGroupPostForm onSubmit={handleSubmit} />
        )}
      </YStack>
    </FullScreenDialog>
  )
}
